/**
 * Hospitais - espelho das Organizations do Auth (spec 0003, req. 11).
 *
 * "Hospital" e o nome que o negocio usa; no Auth e uma Organization, e pode ser hospital, plano ou
 * area. Serve para agrupar relatorios e para RLS filtrado por organizacao (spec 0005).
 */

import { useQuery } from '@tanstack/react-query'

import { fetchHospitals } from '../api/catalog'
import { RESOURCE_CATALOGO } from '../api/types'
import type { Hospital } from '../api/types'
import { usePermissoes } from '../auth/permissoes'
import type { CampoMeta } from '../listagem/campos'
import { IdCurto, Listagem, Marca } from '../listagem/Listagem'
import { Resultado } from '../listagem/Resultado'

const CAMPOS: Array<CampoMeta<Hospital>> = [
  { nome: 'name', rotulo: 'Nome', grupo: 'Identificação' },
  { nome: 'slug', rotulo: 'Slug', grupo: 'Identificação', formato: 'codigo' },
  {
    nome: 'status',
    rotulo: 'Status',
    grupo: 'Identificação',
    exibir: (item) => <Marca valor={item.status} />,
    nota: 'Vem do Auth. Para mudar, mude lá e ressincronize.',
  },
  {
    nome: 'auth_organization_id',
    rotulo: 'Organization no Auth',
    grupo: 'Vínculo',
    formato: 'identificador',
    nota: 'Políticas de RLS por organização usam este valor como identidade.',
  },
  { nome: 'client_slug', rotulo: 'Cliente', grupo: 'Vínculo', formato: 'codigo' },
  { nome: 'client_id', rotulo: 'Cliente (identificador)', grupo: 'Registro', formato: 'identificador' },
  { nome: 'id', rotulo: 'Identificador no catálogo', grupo: 'Registro', formato: 'identificador' },
]

export function HospitaisPage() {
  const { pode } = usePermissoes()
  const consulta = useQuery({ queryKey: ['hospitals'], queryFn: fetchHospitals })

  return (
    <>
      <Resultado consulta={consulta}>
        {(hospitais) => (
          <Listagem<Hospital>
            itens={hospitais}
            chave="hospitals"
            entidade="hospitals"
            rotulo="hospital"
            rotuloPlural="hospitais"
            campos={CAMPOS}
            podeGerenciar={pode(RESOURCE_CATALOGO, 'manage')}
            idDe={(item) => item.id}
            nomeDe={(item) => item.name}
            ressincroniza
            colunas={[
              { titulo: 'Nome', valor: (item) => item.name },
              { titulo: 'Slug', valor: (item) => <code>{item.slug}</code> },
              { titulo: 'Cliente', valor: (item) => item.client_slug },
              {
                titulo: 'Organization no Auth',
                valor: (item) => <IdCurto valor={item.auth_organization_id} />,
              },
              { titulo: 'Status', valor: (item) => <Marca valor={item.status} /> },
            ]}
            vazio="Nenhum hospital mapeado. O mapeamento é feito no onboarding, passo 2."
          />
        )}
      </Resultado>
    </>
  )
}
